import React from 'react';
import { PathershipInfoModifyButton as PathershipInfoModifyButtonBase, SupplierInfoModifyButton as SupplierInfoModifyButtonBase } from '@purchase/supplier';

export const PathershipInfoModifyButton = (
  props: React.ComponentProps<typeof PathershipInfoModifyButton>
) => {
  return <PathershipInfoModifyButtonBase {...props} />;
};

export const SupplierInfoModifyButton = (
  props: React.ComponentProps<typeof SupplierInfoModifyButton>
) => {
  return <SupplierInfoModifyButtonBase {...props} />;
};
